import { useMutation } from '@fv/client-core'
import type { Currency } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

type TargetPrice = {
  targetPrice: number
  targetPriceCurrency: Currency
  loadId: string
}

const postTargetPrice = async (dto: TargetPrice) => {
  return await shipperFetch(`/shipments/${dto.loadId}/update-target-price`, {
    body: {
      targetPrice: dto.targetPrice,
      targetPriceCurrency: dto.targetPriceCurrency,
    },
    method: 'POST',
  })
}

export const useUpdateTargetPrice = () => {
  return useMutation(postTargetPrice)
}
